export interface SupportContact {
  name: string;
  phone: string;
}

export const supportContacts: SupportContact[] = [
  {
    name: 'Aji Laka',
    phone: '+62 822-4270-6875',
  },
  {
    name: 'Dwi Teguh Mulyono Laka Lantas',
    phone: '+62 857-4794-0347',
  },
  {
    name: 'Laka Pak Mustofa',
    phone: '+62 811-2727-305',
  },
  {
    name: 'Laka WAHYU Timur',
    phone: '+62 813-9246-6590',
  },
  {
    name: 'M Ikwan Laka Lantas',
    phone: '+62 812-2540-8555',
  },
  {
    name: 'Redy (Laka Lantas)',
    phone: '+62 812-2980-8880',
  },
  {
    name: 'Teguh Setiawan (Laka Lantas)',
    phone: '+62 812-2687-4777',
  },
  {
    name: 'Verdy Laka Lantas',
    phone: '+62 813-2556-3655',
  },
  {
    name: 'Cris Dishub Grobogan',
    phone: '+62 857-4055-5707',
  },
  {
    name: 'Joko Dishub',
    phone: '+62 822-7854-3105',
  },
];
